import { connect } from 'react-redux';
import * as effects from '../effects';
import { compose, lifecycle, withState } from 'recompose';
import { selectUserWorkMode } from '../selectors';

const mapStateToProps = (state) => ({
  userWorkMode: selectUserWorkMode(state),
});

const mapDispatchToProps = {
  onFetch: effects.fetchUser,
  onSetLocale: effects.setLocale,
};

const enchance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('workMode', 'setWorkMode', ''),
  lifecycle({
    componentDidMount() {
      const { workMode, userWorkMode, setWorkMode, onWorkModeChange } = this.props;

      this.props.onFetch();
      this.props.onSetLocale();

      if (userWorkMode !== workMode) {
        setWorkMode(userWorkMode);
        onWorkModeChange(userWorkMode);
      }
    },
    componentDidUpdate() {
      const { workMode, userWorkMode, setWorkMode, onWorkModeChange } = this.props;

      if (userWorkMode !== workMode) {
        setWorkMode(userWorkMode);
        onWorkModeChange(userWorkMode);
      }
    },
  })
);

export const UserConnector = enchance(() => null);
